import Content, { HTMLContent } from './Content';

export { HTMLContent }
export default Content;